<template>
  <div>
    <el-select
      v-model="typeSelected"
      :clearable="isClearable"
      :size="inputSize"
      placeholder="Seleccione tipo de factura"
      @change="OnInvoiceTypeSelected"
    >
      <el-option
        v-for="item in typeOptions"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "InvoiceType",
  props: {
    initialValue: {
      type: String,
      default: "",
      required: false
    },
    inputSize: {
      type: String,
      default: "large",
      required: false
    },
    isClearable: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      typeOptions: [
        {
          value: "c",
          label: "Costos"
        },
        {
          value: "g",
          label: "Gastos"
        },
        {
          value: "p",
          label: "Préstamos"
        },
        {
          value: "a",
          label: "Gastos AB"
        }
      ]
      // typeSelected: this.initialValue
    };
  },
  computed: {
    typeSelected() {
      return this.initialValue;
    }
  },
  mounted() {},

  methods: {
    OnInvoiceTypeSelected(type) {
      // console.log("OnInvoiceTypeSelected 1: ", type);

      this.$emit("OnInvoiceTypeSelected", type);
    }
  }
};
</script>

<style scoped></style>
